import React from "react";

import {
  RightSidebar,
  RightSidebarHeader,
  RightSidebarSaveFooter,
  styles
} from "../RightSidebar";
import { Spinner } from "@blueprintjs/core";

function LoadingProductSidebar({ tabTitles, onDismiss }) {
  return (
    <RightSidebar>
      <RightSidebarHeader
        title="Edit Product"
        tabTitles={tabTitles}
        onDismiss={onDismiss}
        loading
      />

      <Spinner className={styles.sidebarLoadingSpinner} />

      <RightSidebarSaveFooter onCancel={onDismiss} saveIsDisabled />
    </RightSidebar>
  );
}

export default LoadingProductSidebar;
